export const APILIST = {
    LOGIN_API: "/api/auth/login",
    FORGOT_PASSWORD:"/api/auth/forgot-password",
    GET_DASHBOARD_ANALYTICS:"/api/admin/analytics",
    GET_USERS_INTERPRETER:"/api/user/get-all",
    INTERPRETER_STATUS_UPDATED:"api/base/up/user",
    INTERPRETER_USER_ADMIN_LANGUAGE_COMMISSION:"api/user/update-language-commission",
    GET_BY_ID_USERS_INTERPRETOR:"/api/user/get-details",
    GET_MILISTONE_USERS_INTERPRETOR:"/api/user/get-milestone",
    GET_PLAN_USERS_INTERPRETOR:"/api/plan/get-plan",
    USER_ACCOUNT_STATUS:"api/user/account-status",
    GET_BY_ID_USERS_INTERPRETO:"/api/user",
    ADD_SIGN_CONTRACTS:"/api/base/in/agreement",
    UPDATE_SIGN_CONTRACTS:"/api/base/up/agreement",
    GET_SIGN_CONTRACTS:"/api/base/get",
    GET_BY_ID_JOB_INTERPRETER:"/api/user/get-user-all-session",

    // ===== REPORT ======
    GET_REPORT_USERS:"/api/user/get-reported-user",
    GET_BY_ID_REPORT_USERS:"/api/user/get-reported-user-details",

    // ===== LANGUAGE ======
    GET_INCOMPLETE_JOB:"api/job/get-incomplete-job",
    GET_BY_ID_JOB_INCOMPLETE:"api/job/get-details",

    GET_RATE_AND_REVIEW:"api/job/rate-and-review",
    GET_UNAVAILABILTIY:"api/user/get-unavailability",
    GET_ANALYTICS:"api/user/user-analytics",
    ADD_NOTIFICATION:"api/notification/send-topic-notification",
    GET_NOTIFICATION:"api/notification/get-all",
    ADD_UPDATE_FCM_TOKEN:"/api/notification/fcm-add-update",
    NOTIFICATION_UNREAD_COUNT:"/api/notification/read-notification",
    GET_DASHBOARD_LINE_CHART:"/api/admin/line-chart",
    GET_ALL_LANGUAGE:"/api/base/get",
    POST_NEW_LANGUAGE_ACCEPT_REJECT_API:"/api/user/approve-reject-user-language",
    GET_LANGUAGE_HOURLY_RATE_REQUEST:"/api/user/get-hourly-rate-change-request",
    POST_LANGUAGE_HOURLY_RATE_REQUEST:"/api/user/approve-reject-language-rate-change-request",
    APPROVE_REJECT_USER_LANGUAGE_API:"/api/user/approve-reject-user-language",
    GET_NOTIFICATION_UNREAD_COUNT_API:"/api/notification/unread-count",


    POST_USER_REFUND_AMOUNT:"/api/stripe/refund-payment-intent",
    POST_USER_TRANSFER_AMOUNT:"/api/stripe/create-transfer",
    POST_USER_TRAINSFER_AMOUNT_CHECK :"/api/stripe/retrive-payment-intent",


    ADD_COIN_ADJUSMENT_API:"/api/coin/create-transaction",
    GET_ALL_COIN_ADJUSMENT_API:"/api/coin/coin-transaction",
    GET_REFERRALS_API:"/api/user/get-referrals",



    GET_SESSION_DETAILS:"/api/job/get-details",
    ADD_UPDATE_CERTIFICATE_REQUEST:"api/base/up/user_certificate",
    GET_ALL_JOB_REPORTS:"/api/job/get-reported-jobs",
    GET_BY_ID_JOB_REPORTS:"/api/job/get-reported-job-details",
    GET_ALL_ADMIN_SESSIONS:"/api/job/get-all-session",
    ADMIN_ASSIGN_INTERPRETER_PLAN:"/api/plan/purchase-plan"

}
export default APILIST
